import { render, staticRenderFns } from "./SVG_TriangleLogo.vue?vue&type=template&id=6515373a&scoped=true&"
var script = {}
import style0 from "./SVG_TriangleLogo.vue?vue&type=style&index=0&id=6515373a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6515373a",
  null
  
)

export default component.exports